module.exports = __webpack_public_path__ + "static/media/stranger_things_bg.6627765f.png";